import { StateCreator } from "zustand";
import { EXAM_SUPERVISOR } from "../../constants/exam-supervisor";
import {
  ExamSupervisorSetting,
  AttentdantSetting,
} from "../../types/examSupervisor";

export interface ExamSupervisorState {
  examSupervisorSetting: ExamSupervisorSetting | null;
  attedantSetting: AttentdantSetting['data'] | null;
  recordVideoTime: number;
  recordedVideo: Blob[];
  violenList: { type: EXAM_SUPERVISOR; time: string }[];
  setRecordedVideo: (data: Blob[]) => void;
  setViolenList: (data: { type: EXAM_SUPERVISOR; time: string }[]) => void;
  setSaveRecordVideoTime: (count: number) => void;
  resetSupervisorData: () => void;
  setExamSupervisorSetting: (data: ExamSupervisorSetting) => void;
  setAttendantSetting: (data: AttentdantSetting['data']) => void;
}

export const examSupervisorSlice: StateCreator<ExamSupervisorState> = (
  set
) => ({
  examSupervisorSetting: null,
  attedantSetting: null,
  recordVideoTime: 0,
  recordedVideo: [],
  violenList: [],
  setExamSupervisorSetting: (data) => set({ examSupervisorSetting: data }),
  setAttendantSetting: (data) => set({ attedantSetting: data }),
  setRecordedVideo: (data) => set({ recordedVideo: data }),
  setViolenList: (data) => {
    set((state) => ({
      violenList: [...state.violenList, ...data],
    }));
  },
  setSaveRecordVideoTime: (count) => set({ recordVideoTime: count }),
  resetSupervisorData: () =>
    set({
      recordedVideo: [],
      recordVideoTime: 0,
      violenList: [],
      examSupervisorSetting: null,
      attedantSetting: null,
    }),
});
